import { Base } from "ui/Scripts/source/framework/base";

export interface IMessageEditItemTargetCompanyGroup {
    id: string;
    code: string;
    title: string;
    logo: string;
}

export class MessageEditItemTargetCompanyGroup implements IMessageEditItemTargetCompanyGroup {
    id: string;
    code: string;
    title: string;
    logo: string;

    constructor();
    constructor(obj: IMessageEditItemTargetCompanyGroup);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.title = obj && obj.title || "";
        this.logo = obj && obj.logo || "";
    }

    static sort(items: IMessageEditItemTargetCompanyGroup[]): IMessageEditItemTargetCompanyGroup[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IMessageEditItemTargetCompanyGroup, b: IMessageEditItemTargetCompanyGroup) => { return (!a || !b) ? 0 : (Base.strCompare(a.title, b.title)); });
    }
}

export class MessageEditItemTargetCompanyGroupSave {
    id: string;
    code: string;

    constructor();
    constructor(obj: IMessageEditItemTargetCompanyGroup);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
    }
}